export enum MfaMethod {
    SMS = 'sms',
    EMAIL = 'email'
};
